import { takeEvery, takeLatest } from "redux-saga/effects";
import ApiConstants from "../../Globals/ApiConstants";
import {
    addProductSaga,
    apparelLoginSaga,
    sendLoginOtpSaga,
    verifyLoginOtpSaga,
    categoryAndSubCategoryListSaga,
    createBillSaga,
    createBillSaga_V2,
    createCustomerSaga,
    mergeCustomerSaga,
    setCustomerCreditLimitSaga,
    addCustomerCreditOpeningBalanceSaga,
    recordCustomerCreditSettlementSaga,
    getCustomerCreditLedgerSaga,
    createOrUpdateCycleCountSaga,
    getBillingListSaga,
    getBillNavigationRowSaga,
    getCustomerHistorySaga,
    getEmployeeSalesHistorySaga,
    getCustomerListSaga,
    getCycleCountListSaga,
    cycleCountListSearch,
    getInvoiceDetailsSaga,
    getListSaga,
    getMultipleInventoryCountsSaga,
    getMultipleInventoryDamagedListSaga,
    getMultipleInventorySoldListSaga,
    getMultipleSubcategoryListSaga,
    getProductHistorySaga,
    getProductItemSaga,
    getProductListSaga,
    getReferenceDataSaga,
    updateMultipleInventorySaga,
    updateProductItemColorOrSizeSaga,
    updateProductStatusSaga,
    updateStickeringStatusSaga,
    getProductListCategorySaga,
    getUpdataCycleCountSaga,
    updateCycleCountListSaga,
    getMultipleInventoryScrapListSaga,
    getCycleCountReportListSaga,
    getReportListSaga,
    getVendorListSaga,
    createOrUpdateVendorSaga,
    getVenderEmailValidationSaga,
    getVendorDropDownListSaga,
    getVendorPurchaseListSaga,
    getRentalListSaga,
    createOrUpdateRentalSaga,
    createOrUpdateVendorPurchaseSaga,
    getVendorPurchaseHistorySaga,
    getVendorDebtLedgerSaga,
    createVendorDebtEntrySaga,
    getMrpListSaga,
    getEmployeeListSaga,
    createOrUpdateEmployeeSaga,
    getEmployeeDropDownListSaga,
    createOrUpdateProcurementSaga,
    creatOrUpdateAttachmentSaga,
    getAttachmentSaga,
    getVendorBillAttachmentSaga,
    getVendorDebtAttachmentSaga,
    getProcurementSaga,
    getProcurementExportListSaga,
    getAuditLogListSaga,
    getSalesReturnSaga,
    createOrUpdateSalesReturnSaga,
    getSalesReturnBasedOnProductIdSaga,
    getSalesReturnBillDetailsSaga,
    addCategorySaga,
    createOrUpdateBannerSaga,
    getMetaBannerSaga,
    getBannerAttachmentSaga,
    addSubCategorySaga,
    getHotNewTopPickSaga,
    createOrUpdateHotNewTopPickSaga,
    getOnlineOrderSaga,
    updateOrdersSaga,
    getCoreCategoryMetaSaga,
    getDashboardDataSaga,
    getTopProductsSaga,
    getTopCustomersSaga,
    getSalesDashboardDataSaga,
    getInventoryDashboardDataSaga,
    getCustomerDashboardDataSaga,
    getVendorDashboardDataSaga,
    getCustomerCreditDashboardDataSaga,
    getVendorDebtDashboardDataSaga,
    getEmployeeDashboardDataSaga,
    getCustomDashboardDataSaga,
    getUpcomingCustomerEventsSaga,
    getStockHistorySaga,
    getStockMovementHistorySaga,
    adminAdjustStockSaga,
    getComboComponentOptionsSaga,
    getComboItemsSaga,
    getAttendanceListSaga,
    getEmployeeAttendanceCalendarSaga,
    getEmployeeAttendanceSummarySaga,
    getAttendanceRecordByIdSaga,
    markAttendanceSaga,
    getFeedbackDashboardDataSaga,
    getFeedbackListSaga,
    getFeedbackLocationsSaga
} from "./apparelSaga";

export default function* rootSaga() {
    yield takeEvery(ApiConstants?.API_GET_LIST_LOAD, getListSaga)
    yield takeEvery(ApiConstants?.API_CREATE_CUSTOMER_LOAD, createCustomerSaga)
    yield takeEvery(ApiConstants?.API_MERGE_CUSTOMER_LOAD, mergeCustomerSaga)
    yield takeEvery(ApiConstants?.API_SET_CUSTOMER_CREDIT_LIMIT_LOAD, setCustomerCreditLimitSaga)
    yield takeEvery(ApiConstants?.API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_LOAD, addCustomerCreditOpeningBalanceSaga)
    yield takeEvery(ApiConstants?.API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_LOAD, recordCustomerCreditSettlementSaga)
    yield takeEvery(ApiConstants?.API_GET_CUSTOMER_CREDIT_LEDGER_LOAD, getCustomerCreditLedgerSaga)
    yield takeEvery(ApiConstants?.API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_LOAD, updateProductItemColorOrSizeSaga)
    yield takeEvery(ApiConstants?.API_ADD_PRODUCT_LOAD, addProductSaga)
    yield takeEvery(ApiConstants?.API_CATEGORY_AND_SUBCATEGORY_LIST_LOAD, categoryAndSubCategoryListSaga)
    yield takeEvery(ApiConstants?.API_UPDATE_PRODUCT_STATUS_LOAD, updateProductStatusSaga)
    yield takeEvery(ApiConstants?.API_UPDATE_STICKERING_LOAD, updateStickeringStatusSaga)
    yield takeEvery(ApiConstants?.API_GET_PRODUCT_LIST_LOAD, getProductListSaga)
    yield takeEvery(ApiConstants?.API_GET_CUSTOMER_LIST_LOAD, getCustomerListSaga)
    yield takeEvery(ApiConstants?.API_GET_REFERENCE_DATA_LOAD, getReferenceDataSaga)
    yield takeLatest(ApiConstants?.API_GET_PRODUCT_ITEM_LOAD, getProductItemSaga)
    yield takeEvery(ApiConstants?.API_CREATE_BILL_LOAD, createBillSaga)
    yield takeEvery(ApiConstants?.API_CREATE_BILL_V2_LOAD, createBillSaga_V2)
    yield takeEvery(ApiConstants?.API_GET_BILLING_LIST_LOAD, getBillingListSaga)
    // takeLatest: rapid Prev/Next clicks (or the hook's own skip-to-nearest
    // retries) should only act on the most recent probe's response.
    yield takeLatest(ApiConstants?.API_GET_BILL_NAVIGATION_ROW_LOAD, getBillNavigationRowSaga)
    yield takeEvery(ApiConstants?.API_APPAREL_LOGIN_LOAD, apparelLoginSaga)
    yield takeEvery(ApiConstants?.API_SEND_LOGIN_OTP_LOAD, sendLoginOtpSaga)
    yield takeEvery(ApiConstants?.API_VERIFY_LOGIN_OTP_LOAD, verifyLoginOtpSaga)
    yield takeEvery(ApiConstants?.API_GET_CUSTOMER_HISTORY_LOAD, getCustomerHistorySaga)
    yield takeEvery(ApiConstants?.API_GET_EMPLOYEE_SALES_HISTORY_LOAD, getEmployeeSalesHistorySaga)
    yield takeEvery(ApiConstants?.API_GET_PRODUCT_HISTORY_LOAD, getProductHistorySaga)
    yield takeEvery(ApiConstants?.API_GET_INVOICE_DETAILS_LOAD, getInvoiceDetailsSaga)
    yield takeEvery(ApiConstants?.API_UPDATE_MULTIPLE_INVENTORY_LOAD, updateMultipleInventorySaga)
    yield takeEvery(ApiConstants?.API_GET_MULTIPLE_INVENTORY_COUNT_LOAD, getMultipleInventoryCountsSaga)
    yield takeEvery(ApiConstants?.API_GET_MULTIPLE_INVENTORY_SOLD_LIST_LOAD, getMultipleInventorySoldListSaga)
    yield takeEvery(ApiConstants?.API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_LOAD, getMultipleInventoryDamagedListSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_CYCLE_COUNT_LOAD, createOrUpdateCycleCountSaga)
    yield takeEvery(ApiConstants?.API_GET_CYCLE_COUNT_LIST_LOAD, getCycleCountListSaga)
    yield takeEvery(ApiConstants?.API_CYCLE_COUNT_LIST_SEARCH_LOAD, cycleCountListSearch)
    yield takeEvery(ApiConstants?.API_GET_CATEGORY_SUBCATEGORY_LIST_LOAD, getMultipleSubcategoryListSaga)
    yield takeEvery(ApiConstants?.API_GET_PRODUCT_LIST_CATEGORY_LIST_LOAD, getProductListCategorySaga)
    yield takeEvery(ApiConstants?.API_GET_UPDATE_CYCLE_COUNT_LOAD, getUpdataCycleCountSaga)
    yield takeEvery(ApiConstants?.API_UPDATE_CYCLE_COUNT_LIST_LOAD, updateCycleCountListSaga)
    yield takeEvery(ApiConstants?.API_GET_MULTIPLE_SCRAP_LIST_LOAD, getMultipleInventoryScrapListSaga)
    yield takeEvery(ApiConstants?.API_GET_CYCLE_COUNT_REPORT_LOAD, getCycleCountReportListSaga)
    yield takeEvery(ApiConstants?.API_GET_REPORT_LIST_LOAD, getReportListSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_LIST_LOAD, getVendorListSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_LOAD, createOrUpdateVendorSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_EMAIL_VALIDATION_LOAD, getVenderEmailValidationSaga)
    yield takeEvery(ApiConstants?.VENDOR_DROP_DOWN_LIST_LOAD, getVendorDropDownListSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_PURCHASE_LIST_LOAD, getVendorPurchaseListSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_PURCHASE_LOAD, createOrUpdateVendorPurchaseSaga)
    yield takeEvery(ApiConstants?.API_GET_RENTAL_LIST_LOAD, getRentalListSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_RENTAL_LOAD, createOrUpdateRentalSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_PURCHASE_HISTORY_LOAD, getVendorPurchaseHistorySaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_DEBT_LEDGER_LOAD, getVendorDebtLedgerSaga)
    yield takeEvery(ApiConstants?.API_CREATE_VENDOR_DEBT_ENTRY_LOAD, createVendorDebtEntrySaga)
    yield takeEvery(ApiConstants?.MRP_LIST_LOAD, getMrpListSaga)
    yield takeEvery(ApiConstants?.API_GET_EMPLOYEE_LIST_LOAD, getEmployeeListSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_EMPLOYEE_LOAD, createOrUpdateEmployeeSaga)
    yield takeEvery(ApiConstants?.EMPLOYEE_DROP_DOWN_LIST_LOAD, getEmployeeDropDownListSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_PROCUREMENT_LOAD, createOrUpdateProcurementSaga)
    yield takeEvery(ApiConstants?.API_GET_PROCUREMENT_LIST_LOAD, getProcurementSaga)
    yield takeEvery(ApiConstants?.API_GET_PROCUREMENT_EXPORT_LIST_LOAD, getProcurementExportListSaga)
    yield takeEvery(ApiConstants?.API_GET_AUDIT_LOG_LIST_LOAD, getAuditLogListSaga)
    yield takeEvery(ApiConstants?.API_GET_SALES_RETURN_LIST_LOAD, getSalesReturnSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_SALES_RETURN_LOAD, createOrUpdateSalesReturnSaga)
    yield takeEvery(ApiConstants?.API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_LOAD, getSalesReturnBasedOnProductIdSaga)
    yield takeEvery(ApiConstants?.API_GET_SALES_RETURN_BILL_DETAILS_LOAD, getSalesReturnBillDetailsSaga)
    yield takeEvery(ApiConstants?.API_CREATE_OR_UPDATE_ATTACHMENT_LOAD, creatOrUpdateAttachmentSaga)
    yield takeEvery(ApiConstants?.API_GET_ATTACHMENT_LOAD, getAttachmentSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_BILL_ATTACHMENT_LOAD, getVendorBillAttachmentSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_DEBT_ATTACHMENT_LOAD, getVendorDebtAttachmentSaga)
    yield takeEvery(ApiConstants?.API_ADD_CATEGORY_ON_LOAD, addCategorySaga)
    yield takeEvery(ApiConstants?.API_CREATE_UPDATE_BANNER_LOAD, createOrUpdateBannerSaga)
    yield takeEvery(ApiConstants?.API_GET_BANNER_LOAD, getMetaBannerSaga)
    yield takeEvery(ApiConstants?.API_GET_BANNER_ATTACHMENT_LOAD, getBannerAttachmentSaga)
    yield takeEvery(ApiConstants?.API_ADD_SUB_CATEGORY_ON_LOAD, addSubCategorySaga)
    yield takeEvery(ApiConstants?.API_GET_HOT_NEW_TOP_PICK_LOAD, getHotNewTopPickSaga)
    yield takeEvery(ApiConstants?.API_UPDATE_HOT_NEW_TOP_PICK_LOAD, createOrUpdateHotNewTopPickSaga)
    yield takeEvery(ApiConstants?.API_GET_ONLINE_ORDER_LOAD, getOnlineOrderSaga)
    yield takeEvery(ApiConstants?.API_UPDATE_ONLINE_ORDER_LOAD, updateOrdersSaga)
    yield takeEvery(ApiConstants?.API_GET_CORE_CATEGORY_META_LOAD, getCoreCategoryMetaSaga)
    yield takeEvery(ApiConstants?.API_GET_DASHBOARD_DATA_LOAD, getDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_TOP_PRODUCTS_LOAD, getTopProductsSaga)
    yield takeEvery(ApiConstants?.API_GET_TOP_CUSTOMERS_LOAD, getTopCustomersSaga)
    yield takeEvery(ApiConstants?.API_GET_SALES_DASHBOARD_DATA_LOAD, getSalesDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_INVENTORY_DASHBOARD_DATA_LOAD, getInventoryDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_CUSTOMER_DASHBOARD_DATA_LOAD, getCustomerDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_DASHBOARD_DATA_LOAD, getVendorDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_LOAD, getCustomerCreditDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_VENDOR_DEBT_DASHBOARD_DATA_LOAD, getVendorDebtDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_CUSTOM_DASHBOARD_DATA_LOAD, getCustomDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_EMPLOYEE_DASHBOARD_DATA_LOAD, getEmployeeDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_UPCOMING_CUSTOMER_EVENTS_LOAD, getUpcomingCustomerEventsSaga)
    yield takeEvery(ApiConstants?.API_GET_STOCK_HISTORY_LOAD, getStockHistorySaga)
    yield takeEvery(ApiConstants?.API_GET_STOCK_MOVEMENT_HISTORY_LOAD, getStockMovementHistorySaga)
    yield takeEvery(ApiConstants?.API_ADMIN_ADJUST_STOCK_LOAD, adminAdjustStockSaga)
    // takeLatest: the combo picker searches as the user types, and only the
    // newest response should land; Edit Stock's component list likewise.
    yield takeLatest(ApiConstants?.API_GET_COMBO_COMPONENT_OPTIONS_LOAD, getComboComponentOptionsSaga)
    yield takeLatest(ApiConstants?.API_GET_COMBO_ITEMS_LOAD, getComboItemsSaga)
    yield takeEvery(ApiConstants?.API_GET_ATTENDANCE_LIST_LOAD, getAttendanceListSaga)
    yield takeLatest(ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_LOAD, getEmployeeAttendanceCalendarSaga)
    yield takeLatest(ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_LOAD, getEmployeeAttendanceSummarySaga)
    yield takeLatest(ApiConstants?.API_GET_ATTENDANCE_RECORD_BY_ID_LOAD, getAttendanceRecordByIdSaga)
    yield takeEvery(ApiConstants?.API_MARK_ATTENDANCE_LOAD, markAttendanceSaga)
    yield takeEvery(ApiConstants?.API_GET_FEEDBACK_DASHBOARD_DATA_LOAD, getFeedbackDashboardDataSaga)
    yield takeEvery(ApiConstants?.API_GET_FEEDBACK_LIST_LOAD, getFeedbackListSaga)
    yield takeEvery(ApiConstants?.API_GET_FEEDBACK_LOCATIONS_LOAD, getFeedbackLocationsSaga)
}